import { Component, Vue } from 'vue-property-decorator';

// @Component デコレータはクラスが Vue コンポーネントであることを示します
//@Component({
//    // ここではすべてのコンポーネントオプションが許可されています
//    template: '<button @click="onClick">Click!</button>'
//})
@Component
export default class BaseVue extends Vue {
    // 初期データはインスタンスプロパティとして宣言できます
    isPosting = false
    //BlockUI表示制御用フラグ
    protected isProcessing = false

    // コンポーネントメソッドはインスタンスメソッドとして宣言できます
    beginPost() {
        this.isPosting = true;
    }
    endPost() {
        this.isPosting = false;
    }
    async avoidMultipost(func: () => any) {
        if (this.isPosting) {
            return null;
        }
        this.beginPost();
        const res = await func();
        this.endPost();
        return res;
    }
    //#region BlockUI制御
    protected async brockUIProcess(func: () => any) {
        try {
            this.isProcessing = true
            return await func()
        }
        finally {
            this.isProcessing = false
        }
    }
    //#endregion
}